/**
 * @desc 我的邀请记录
 */
import { EnumAPI } from '../../apis';
import { BasesController } from '../bases';
export class InviteController<T = any> extends BasesController<T> {
    constructor() {
        super({
            dataKey: 'id',
            infinite: true,
            pagination: EnumAPI.bffsvr_invitationPage_list,
            paginationParams: {
                currentKey: 'curPageNo',
                pageSizeKey: 'pageSize',
                filterKey: 'search',
                response: {
                    dataSource: 'recordList',
                    total: 'recordCount'
                }
            }
        })
    }
}